import { homedir } from "os";

const CONFIG = {
    CUSTOMER_ID: '677e7c288b020bd51cfa4cea',
    PAGES_GROUP_ID: '674414d5701373e4a78d96be',
    NEWS_GROUP_ID: '67480c589e2610b83c410119',
    BLOG_GROUP_ID: '674d76509acdcd98de1d9a7e',
    HOME_PAGE_ID: '6752993226e34ea4abac8470',
    CATALOG_GROUP_ID: '67506c5038ff069a6e17b610',
}
export default CONFIG;